var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiIconsIrDerecha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.59 12L8.28748 17.3025L9.34498 18.3675L15.7125 12L9.34498 5.63251L8.28748 6.69751L13.59 12Z",
    fill: "#003865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiIconsIrDerecha);
export default __webpack_public_path__ + "static/media/bi-icons-ir-derecha.828b027fea94ecd0ec6fab1ca23e233f.svg";
export { ForwardRef as ReactComponent };